import { render, staticRenderFns } from "./proportionSetting.vue?vue&type=template&id=893fd184&"
import script from "./proportionSetting.vue?vue&type=script&lang=js&"
export * from "./proportionSetting.vue?vue&type=script&lang=js&"
import style0 from "./proportionSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports